import React from 'react';
// import { FieldGroup } from '../../../libs/formLib';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FormFeedback, FormGroup, Label, Alert } from 'reactstrap';
import { isEmpty } from 'lodash';

const selectStyles = {
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      color: isFocused ? 'white' : isSelected ? 'white' : 'black'
    };
  }
};

const CMDBCompanyCheck = ({ snCompanySysIdOptions, snCompanySysId, setSnCompanySysId, isSubmitted }) => {
  return (
    <FormGroup data-testid={'vendor-sys-id'}>
      <Label>
        Vendor System ID (ServiceNow)<span style={{ color: '#bd472a' }}>*</span>
      </Label>
      <Select
        id="companies"
        name="id-select"
        getOptionLabel={option => (isEmpty(option) ? 'Select...' : `${option.label} (${option.value})`)}
        // getOptionLabel={option => `${option.label} (${option.value})`}
        value={snCompanySysId}
        onChange={e => setSnCompanySysId(e)}
        options={snCompanySysIdOptions?.companies}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            text: 'white',
            primary25: '#253746',
            primary: '#bd472a',
            neutral10: '#bd472a',
            dangerLight: '#bf6e4c'
          }
        })}
        styles={selectStyles}
      />
      {snCompanySysIdOptions.companies === null && snCompanySysIdOptions.error.length > 1 ? (
        <Label className="text-danger">{snCompanySysIdOptions.error}</Label>
      ) : (
        ''
      )}
      <FormFeedback
        className={
          isSubmitted && snCompanySysIdOptions?.companies?.length && !snCompanySysId?.value?.length ? 'd-block' : ''
        }
        type="invalid"
      >
        <Alert color="danger">Please select an ID.</Alert>
      </FormFeedback>
    </FormGroup>
  );
};
CMDBCompanyCheck.propTypes = {
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  setSnCompanySysId: PropTypes.func,
  isSubmitted: PropTypes.bool,
  loading: PropTypes.bool
};

export default CMDBCompanyCheck;
